<template>
  <v-bottom-sheet
    v-model="drawer"
    close-delay="1000"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-model="drawer"
        v-bind="attrs"
        v-on="on"
        icon
      >
        <v-icon large>mdi-menu</v-icon>
      </v-btn>
    </template>

    <v-card height="50vh">
      <v-list-item>
        <v-list-item-content>
          Menu
        </v-list-item-content>
        <v-list-item-icon>
          <v-btn
            icon
            @click="drawer = !drawer"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item-icon>
      </v-list-item>
      <v-divider></v-divider>
      
      <v-list-item 
        v-for="(router, idx) in routers"
        :key="idx"
        :exact="idx===0"
        :to="router.to"
        class="font-weight-black"
        @click="drawer = !drawer"
      >
        <v-list-item-content>
          {{ router.title }}
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
export default {
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(value) {
        this.$store.commit('showDrawer', value)
      }
    },
    routers() {
      return this.$store.state.routers;
    }
  }
}
</script>